export default {
  setCMSData(state, settings) {
    state.cmsData = settings
  },
  setGoodList(state, payload) {
    console.log('setGoodList----------', payload)
    state.goodList = payload
  },
  setRaiserList(state, payload) {
    console.log('renzhengRasier----------', payload)
    state.rasierList = payload
  },
  setConsultantList(state, payload) {
    state.consultantList = payload
  },
  setMenuList(state, payload) {
    state.menuList = payload
  },
  setShopkeeperList(state, payload) {
    state.shopkeeperList = payload
  },
  setShopkeeperDetail(state, payload) {
    state.shopkeeperDetail = payload
    console.log('setShopkeeperDetail', state.shopkeeperDetail)
  },
  setStoreList(state, payload) {
    state.storeList = payload
    console.log('setstoreList', state.storeList)
  },
  setCommentList(state, payload) {
    state.commentList = payload
    console.log('setstoreList', state.commentList)
  }
}
